import axios from 'axios';
import { useCallback } from 'react';
import { isEmpty } from 'lodash';

export function useFetcher({ user }) {
  const fetcher = useCallback(
    ({ method = 'GET', url, data = {}, contentType }) => {
      const { accessToken } = user;

      return axios({
        method,
        url,
        ...(!isEmpty(data) && { data }),
        headers: {
          'Content-Type': contentType || 'application/json',
          ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
        },
      }).then(({ data }) => data);
    },
    [user]
  );

  return fetcher;
}
